import * as adobeUtils from './adobeUtils';
import event, { EventFn } from './event';
import initializer, { InitClientFn } from './initializer';
import stateManager, { UpdateStateFn } from './stateManager';
import { sendPageview, SendPageview } from './sendPageview';

export interface Client {
    event: EventFn;
    utils: {
        updateState: UpdateStateFn;
        getAdobeData: adobeUtils.GetAdobeDataFn;
        sendPageview: SendPageview;
    };
    init: InitClientFn;
}

// Create a client capable of caching all calls to the `events` methods, until it is initiated.
const client: Client = {
    event,
    init: initializer.initClient,
    utils: {
        sendPageview,
        getAdobeData: adobeUtils.getAdobeData,
        updateState: stateManager.update,
    },
};

export default client;
